// This file exists to distinguish debug code (console.log) and actually needed logging (consoleLog).
// Developers can find debug code quicker this way.
// Every argument passed through the functions below is scrubbed of personal data and
// credentials before it reaches the real console method, so call sites should not rely on
// seeing raw e-mails/tokens in the console output.
//
// Kept as CommonJS and free of syntax that needs Babel helpers (spread, for-of, destructuring):
// the helpers are injected as ESM imports, which makes webpack treat this file as an ES module
// and drop module.exports. It is also required from server/index.js under plain Node.
var scrubValue = require('./scrub').scrubValue;

function wrap(consoleMethod) {
    return function () {
        var scrubbed = [];
        try {
            for (var i = 0; i < arguments.length; i++) {
                scrubbed.push(scrubValue(arguments[i]));
            }
        } catch (e) {
            return consoleMethod.apply(console, ['[log] could not scrub arguments', e && e.message]);
        }
        return consoleMethod.apply(console, scrubbed);
    };
}

module.exports = {
    consoleDebug: wrap(console.debug),
    consoleLog: wrap(console.log),
    consoleWarn: wrap(console.warn),
    consoleError: wrap(console.error)
};
